module.exports = __webpack_public_path__ + "img/collection-memoireRingsRosegold.937ede6.webp";